module.exports = __webpack_public_path__ + "9496d272f8f6b5030f10cbefeb650cbf.svg";